import { Fragment, useContext } from "react"
import { ActionType, ListGroupTask } from "../../types"
import { Toggle } from "components/actions/Toggle"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { Render } from "../../utils"

export function IsActive({ data, refetch }: ActionType) {
    const api = useApi()
    const { toggle } = useContext(Render)

    const onSubmit = (value: ListGroupTask) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.put("/group-task/changestatus",
                    {
                        mr_group_task_id: value.mr_group_task_id,
                        group_task_del: !value.is_deleted
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            )
            .then(() => {
                toggle()
                refetch && refetch()
            })
            .catch(() => {})
            .finally(resolve)
        })
    }

    return (
        <Fragment>
            <Toggle
                label="Soft Delete" 
                isChecked={data?.is_deleted} 
                onClick={() => 
                    { onSubmit(data!) }
                    } 
                />
        </Fragment>
    )
}